import { render, staticRenderFns } from "./stadium_curator.vue?vue&type=template&id=80669940&scoped=true&"
import script from "./stadium_curator.vue?vue&type=script&lang=ts&"
export * from "./stadium_curator.vue?vue&type=script&lang=ts&"
import style0 from "./stadium_curator.vue?vue&type=style&index=0&id=80669940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80669940",
  null
  
)

export default component.exports